export default __webpack_public_path__ + "static/media/FAKESME_Dashboard.194e74d4.svg";